module.exports = __webpack_public_path__ + "img/black-vip-label.2b66e520.png";